// import store from 'store';

export const UPDATE_COURSE_BUILDER_PARAMS   =   '[PARAM_HISTORY] UPDATE COURSE BUILDER PARAMS';
export const CLEAR_PARAMS                   =   '[PARAM_HISTORY] CLEAR PARAMS';
export const UPDATE_COMPANY_AUTH_PARAMS     =   '[PARAM_HISTORY] UPDATE COMPANY AUTH';
export const UPDATE_AUTH_PRELOAD_ROLE       =   '[PARAM_HISTORY] UPDATE AUTH PRELOAD ROLE';

export function updateCourseBuilderParams(obj) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_COURSE_BUILDER_PARAMS,
            payload: obj
        })
    }
}

export function updateCompanyAuthParams(obj) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_COMPANY_AUTH_PARAMS,
            payload: obj
        })
    }
}

export function updateAuthPreloadRole(obj) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_AUTH_PRELOAD_ROLE,
            payload: obj
        })
    }
}

export function clearParams() {
    return (dispatch) => {
        dispatch({
            type: CLEAR_PARAMS,
        })
    }
}


// WEBPACK FOOTER //
// src/main/components/paramHistory/store/actions/paramHistory.actions.js